export default __webpack_public_path__ + "static/media/07.a06bfdc7.png";